<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span
        *ngIf="addOrUpdateSettingsOptions.setting.SettingId === undefined">{{ 'Insert' | translate }}
        : {{ 'Settings' | translate }}</span>
      <span
        *ngIf="addOrUpdateSettingsOptions.setting.SettingId !== undefined">{{ 'Update' | translate }}
        : {{ 'Settings' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-0">
  <div class="row my-4 pb-1 ">
    <div class="col-md-6 col-12">
      <app-frontend-dropdown
        (onSelected)="onKeySelect($event)"
        [disabled]="!!addOrUpdateSettingsOptions.setting.SettingId"
        [displayKey]="'Title'"
        [fieldName]="'Value'"
        [isSearchable]="false"
        [options]="keyOptions"
        [required]="true"
        [selectedOptions]="key ? [key] : []"
        [title]="'Type'">
      </app-frontend-dropdown>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-select [(value)]="branchId"
                           [controller]="'businesses'"
                           [disabled]="!!addOrUpdateSettingsOptions.setting.SettingId"
                           [displayKey]="'Title'"
                           [fieldName]="'BusinessId'"
                           [isMultiple]="false"
                           [method]="'getBranches'"
                           [microservice]="Constant.getFoodShop()"
                           [protocolMethod]="'POST'"
                           [required]="true"
                           [searchOnKey]="'Title'"
                           [selectedOptions]="selectedBranch ? [selectedBranch] : []"
                           [title]="'Branch'"
                           [version]="'v1'"></app-frontend-select>
    </div>
    @if ((key?.Value === 'SEND_SMS_TO_ADMINS_FOR_NEW_ORDER' || key?.Value === 'SEND_PUSH_NOTIFICATION_TO_CLIENTS_FOR_NEW_ORDER') && branchId) {
      <div class="col-md-6 col-12">
        <app-frontend-select [(value)]="staffIds"
                             [controller]="'users'"
                             [displayKey]="'FirstName,LastName,MobileNumber,Business_Business.Title'"
                             [fieldName]="'UserId'"
                             [isMultiple]="true"
                             [method]="'get?StaffOnly=true&extra=Business_Business'"
                             [microservice]="Constant.getFoodShop()"
                             [protocolMethod]="'POST'"
                             [required]="true"
                             [searchOnKey]="'FirstName,LastName,MobileNumber'"
                             [selectedOptions]="staffs"
                             [title]="'StaffsToGetPushNotifications'"
                             [version]="'v1'"></app-frontend-select>
      </div>
    }
    <div class="col-md-6 col-12">
      <app-frontend-check-box [(value)]="isActive"
                              [title]="'IsActive'"></app-frontend-check-box>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (onSubmit)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-green'"
                           [disabled]="false"
                           [src]="'icons/tick-square.svg'"
                           [title]="'Submit'"
                           [validationRequired]="true">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
